var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-l3"},[_c('router-view',{attrs:{"name":"sidebar"}})],1),_c('div',{staticClass:"col"},[_c('router-view')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }